import * as Yup from 'yup'
import i18next from 'i18next'
export const CODE_LENGTH = 6

export const validationSchema = Yup.object().shape({
  code: Yup.string()

    .min(CODE_LENGTH, () =>
      i18next.t('common::validation_messages.must_be_exactly', { number: CODE_LENGTH }),
    )
    .max(CODE_LENGTH, () =>
      i18next.t('common::validation_messages.must_be_exactly', { number: CODE_LENGTH }),
    )
    .required('common::validation_messages.required'),
})
